// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Figtree', 'Figtree Fallback', sans-serif"},"className":"__className_8331b8","variable":"__variable_8331b8"};